"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sign_up_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const local_storage_names_1 = require("../../../../constants/local_storage_names");
const main_1 = require("../../main");
const user_1 = require("../user");
const sign_up_1 = require("../../../../api/calls/user/sign_up");
exports.sign_up_thunk = (0, toolkit_1.createAsyncThunk)("user/sign_up_thunk", (arg, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const state = getState();
    const userState = state.userState;
    const { user, isLoading } = userState;
    dispatch((0, user_1.setIsLoading)(true));
    // Call the API.
    let response = null;
    response = yield (0, sign_up_1.sign_up)({
        email: user.email,
        name: user.name,
        surname: user.surname,
        password: user.password,
        confirm_password: user.confirm_password,
        cell_number: (_a = user.cell_number) !== null && _a !== void 0 ? _a : "",
    });
    dispatch((0, user_1.setIsLoading)(false));
    // Handle the response.
    if (response.success) {
        if (user.remember_me) {
            localStorage.setItem(local_storage_names_1.USER_LOCAL_STORAGE, JSON.stringify(response.content));
        }
        dispatch((0, user_1.setUserToken)(response.content.token));
        dispatch((0, user_1.setUser)(response.content.user));
        dispatch((0, user_1.setNewRegistration)(true));
        // New users need to complete FaceTec enrollment before accessing documents
        // This flag will be checked in the signup page to redirect to FaceTec
    }
    else {
        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [response.message] }));
    }
    return response;
}));
